import {Component} from '@angular/core';
@Component({
    selector: 'layout-block-info',
    templateUrl: './sub-block-info.component.html'
})
export class SubBlockInfoComponent {

}
